import { useAgTechAuthContext } from '@agtech/core/auth/AgTechAuthContext'
import React from 'react'
import { Navigate } from 'react-router-dom';

const AgTechWebAppProtectedRoute = (props: { children: JSX.Element }) => {
    const authContext = useAgTechAuthContext();

    if (!authContext.isUserAuthenticated()) {
        return <Navigate to="/login" />;
    }

    return props.children;
}

export default AgTechWebAppProtectedRoute